import { useDispatch, useSelector } from 'react-redux';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import * as Styled from './UploadHeader.styled';
import { Button } from '@cw-ui/form-components';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { FormItem } from '@cw-ui/form-components';
import CloseIcon from '@mui/icons-material/Close';
import { setUploadDialogOpen, setRemoveCurrentFileDialogOpen, bulkImportUsersSliceId } from '../../slice';

const UploadHeader = () => {
    const currentFileName = useSelector(state => state[bulkImportUsersSliceId]?.currentFileName);
    const dispatch = useDispatch();

    const handleUploadClick = () => {
        dispatch(setUploadDialogOpen());
    };

    const handleRemoveFile = () => {
        dispatch(setRemoveCurrentFileDialogOpen());
    };

    const isRemoveFileDisabled = !currentFileName;

    return (
        <Styled.SplitContainer>
            <Styled.Subtext>{formatMessage(Locale.BulkUserImportHeaderSubtext)}</Styled.Subtext>
            <Styled.UploadRow>
                <Styled.UploadButtonContainer>
                    <Button
                        variant="outlined"
                        size="medium"
                        color="secondary"
                        disabled={currentFileName}
                        endIcon={<FileUploadOutlinedIcon />}
                        onClick={handleUploadClick}>
                        {formatMessage(Locale.uploadFile)}
                    </Button>
                </Styled.UploadButtonContainer>
                <FormItem
                    className="textInputFormControl"
                    id="textInputFormItem"
                    labelProps={{
                        disabled: isRemoveFileDisabled,
                        error: false,
                        required: false,
                    }}
                    labelText={formatMessage(Locale.fileName)}
                    size="medium">
                    <Styled.UploadedFileInput
                        endButton={
                            isRemoveFileDisabled
                                ? {}
                                : {
                                      onClick: () => {
                                          handleRemoveFile();
                                      },
                                      endIcon: <CloseIcon />,
                                      text: `${formatMessage(Locale.removeFile)}`,
                                  }
                        }
                        id="id"
                        label="Label"
                        placeholder={formatMessage(Locale.selectFile)}
                        value={currentFileName}
                    />
                </FormItem>
            </Styled.UploadRow>
        </Styled.SplitContainer>
    );
};

export default UploadHeader;
